import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = {};

const syncReducers = {
  setMenu: (state, { payload }) => {
    return { ...payload };
  },
};

const store = createSlice({
  name: "menu",
  initialState: INITIAL_STATE,
  reducers: syncReducers,
});

export const { setMenu } = store.actions;

export default store.reducer;
